export const GET = "GET";
export const PUT = "PUT";
export const POST = "POST";
export const PATCH = "PATCH";
export const DELETE = "DELETE";
